import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SendHeadersService implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the auth header from the service.

    let urlArr = this.route.url.split('/').slice(1)
    
    // const authHeader = this.route.getAuthorizationHeader();
    // Clone the request to add the new header.
     req = req.clone({headers: req.headers.set('localization',localStorage.getItem('lang')? localStorage.getItem('lang') : 'hy')});
     req= req.clone({headers: req.headers.set( 'Access-Control-Allow-Methods' ,'GET,PUT,POST,DELETE,PATCH,OPTIONS')})
    // Pass on the cloned request instead of the original request.
    return next.handle(req);
  }
  constructor(private route: Router) { }
}